module.exports = __webpack_public_path__ + "img/logo-desktop.24b6176e.svg";